import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { Field } from '@alfa-bank/site-form-utils/components/form-field';

import type { TInvestAddressRegistrationField, IDeps } from './models';
import { InvestAddressRegistrationField as Component } from './address-registration-field';
import { AddressRegistrationInput } from './address-registration';

export const InvestAddressRegistrationField = createWidget<IDeps, TInvestAddressRegistrationField>({
    AddressRegistrationInput,
    Field,
})(Component);
